import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Box, Link, useTheme } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { BlackLogo } from '../../../images';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../../hooks';
import { Button } from '../..';
import { setSignedIn, setTokenData } from '../../../redux/reducers';
import UserAvatar from './userAvatar';
import { Link as RouterLink } from 'react-router-dom';

const Header = ({ children, ...containerProps }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { signedIn, userData } = useSelector((state) => state.user);
  const [, setToken] = useLocalStorage('token', null);
  const theme = useTheme();
  const isOrganizationAdmin =
    userData.organization && (userData.organization.isAdmin || userData.organization.isSuperUser);

  const doSignOut = () => {
    // clear local storage
    setToken(null);
    dispatch(setTokenData(null));
    dispatch(setSignedIn(false));
  };

  return (
    <Box width="100%" mb={10}>
      <Flex
        margin={0}
        flexDirection="row"
        alignItems="center"
        bgColor="brand.50"
        px={20}
        py={5}
        {...containerProps}
      >
        <Flex flexDirection="row" alignItems="center" width="100%" flexWrap="wrap">
          <Link
            as={RouterLink}
            to="/interpreter"
            sx={{
              'display': 'flex',
              ':hover': { textDecorationColor: 'white' },
            }}
          >
            <BlackLogo />
            <Text color="white" fontSize="4xl" ml={4} fontWeight="bold" flexGrow={1}>
              {t('chabla').toUpperCase()}
            </Text>
          </Link>
          {children}
          <Box ml={8} d="flex" alignItems="center" alignSelf="flex-end" flexGrow="1">
            {/* FIXME: Replace the empty to link with the actual help link */}
            {isOrganizationAdmin && (
              <>
                <Link color="white" as={RouterLink} to="/interpreter" mr={10}>
                  <Text fontWeight="500" color="brand.100">
                    {t('interpreter.headerLink')}
                  </Text>
                </Link>
                <Link color="white" as={RouterLink} to="/organization" mr={10}>
                  <Text fontWeight="500" color="brand.100">
                    {t('organization.headerLink')}
                  </Text>
                </Link>
              </>
            )}
            <Box flexGrow="1" />
            <Link color="white" as={RouterLink} to="/" mr={10}>
              <Text fontWeight="500" color="brand.100">
                {t('interpreter.help')}
              </Text>
            </Link>
            {signedIn === true && (
              <>
                <UserAvatar firstName={userData.firstname} lastName={userData.lastname} mr={10} />
                <Button
                  color="white"
                  variant="outline"
                  border="2px"
                  bg={null}
                  onClick={() => doSignOut()}
                >
                  {t('login.signOut')}
                </Button>
              </>
            )}
          </Box>
        </Flex>
      </Flex>
      {/*linear-gradients red needs to stop at 48% to get rid of jagged lines in the middle */}
      <Box
        width="100%"
        height="30px"
        position="absolute"
        bgImage={`linear-gradient(to left bottom, ${theme.colors.brand[50]} 0%, ${theme.colors.brand[50]} 48%, transparent 52%)`}
      />
    </Box>
  );
};

Header.propTypes = {
  children: PropTypes.any,
};

Header.defaultProps = {};

export default Header;
